import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import AppRoutes from './routes/AppRoutes';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import { UnhandledErrorBoundary } from './components/UI/errors/UnhandledErrorBoundary';

const App: React.FC = () => {
  return (
    <UnhandledErrorBoundary>
      <Provider store={store}>
        <Router>
          <AppRoutes />
        </Router>
      </Provider>
    </UnhandledErrorBoundary>
  );
};

export default App;
